import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import * as $ from 'jquery';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-professional-editing-service',
  templateUrl: './professional-editing-service.component.html',
  styleUrls: ['./professional-editing-service.component.scss']
})
export class ProfessionalEditingServiceComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('전문 교정 서비스 세부 정보 | AI 트링카');
    this.metaTagService.updateTag({ name: 'description', content: "성공적인 논문 출판을 위해 학술 전문 석박사 원어민 에디터가 제공하는 학술 영어 교정 서비스" });
    this.metaTagService.updateTag({ property: 'og:title', content: "전문 교정 서비스 세부 정보 | AI 트링카" });
    this.metaTagService.updateTag({ property: 'og:description', content: "성공적인 논문 출판을 위해 학술 전문 석박사 원어민 에디터가 제공하는 학술 영어 교정 서비스"});
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/professional-editing-service' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    if (isPlatformBrowser(this.platformId)){
      // $.getScript('../../../assets/js/particles.min.js', function(){});
    }
    
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
